import type { AxiosPromise } from 'axios';

import type {
  GenerateReachoutFromIdsRequestDto,
  GenerateReachoutFromIdsResponseDto,
  StartRjCommunicationPipelineRequestDto,
} from '../model';

import { hosts } from '@/app/config';
import { BaseClient } from '@/clients/BaseClient/BaseClient';

class GenerateAiReachoutMessageClient extends BaseClient {
  generateReachoutMessageFromIds(
    params: GenerateReachoutFromIdsRequestDto,
  ): AxiosPromise<GenerateReachoutFromIdsResponseDto> {
    return this.request({
      url: `${hosts.campaignsApi}/outreach/generate_reachout_message_from_ids`,
      method: 'POST',
      data: params,
    });
  }

  startRjCommunicationPipeline(params: StartRjCommunicationPipelineRequestDto): AxiosPromise<void> {
    const { campaign_id, es_person_id, subject, message, improved_job_id, origin, scheduler_type, schedule_interview } =
      params;
    return this.request({
      url: `${hosts.campaignsApi}/campaigns/${campaign_id}/candidates/${es_person_id}/rj_communication_hub/start/`,
      method: 'POST',
      data: {
        ...(subject ? { subject } : {}),
        ...(message ? { message } : {}),
        improved_job_id,
        ...(origin != null ? { origin } : {}),
        ...(scheduler_type != null ? { scheduler_type } : {}),
        ...(schedule_interview !== undefined ? { schedule_interview } : {}),
      },
    });
  }
}

export const generateAiReachoutMessageClient = new GenerateAiReachoutMessageClient();
